import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import Bande from '../components/Bande';
import { ENTREPRISE, LEGAL } from '../data/site';
import { CATEGORIES } from '../components/consentement';
import SectionContact from '../components/SectionContact';

function Cadre({ titre, chapo, enfants }) {
  return (
    <>
      <section className="bg-nuit text-white relative overflow-hidden">
        <div className="absolute inset-0 trame-diagonale" aria-hidden="true" />
        <div className="conteneur relative py-12 sm:py-14">
          <h1 className="font-display uppercase text-[32px] sm:text-[42px] leading-[1]">{titre}</h1>
          {chapo && <p className="mt-4 text-white/75 max-w-2xl text-[17px]">{chapo}</p>}
        </div>
        <Bande hauteur={6} />
      </section>
      <section className="bg-white py-12 sm:py-16">
        <div className="conteneur max-w-3xl space-y-9 text-nuit/85">{enfants}</div>
      </section>
      <section className="bg-trame py-10">
        <div className="conteneur max-w-3xl flex flex-wrap gap-3">
          <Link to="/mentions-legales" className="btn-ligne !py-2.5 !px-5 !text-[14px]">Mentions légales</Link>
          <Link to="/confidentialite" className="btn-ligne !py-2.5 !px-5 !text-[14px]">Confidentialité</Link>
          <Link to="/cookies" className="btn-ligne !py-2.5 !px-5 !text-[14px]">Cookies</Link>
          <Link to="/charte-avis" className="btn-ligne !py-2.5 !px-5 !text-[14px]">Charte des avis</Link>
          <Link to="/contact" className="btn-jaune !py-2.5 !px-5 !text-[14px]">Nous contacter</Link>
        </div>
      </section>
      <SectionContact
        avant="Une question sur ce "
        mot="document ?"
        intro="Écrivez-nous, on répond en quelques heures. Vous pouvez aussi nous joindre directement par téléphone."
      />
    </>
  );
}

const H = ({ children }) => (
  <h2 className="font-display uppercase text-[22px] sm:text-[25px] text-nuit">{children}</h2>
);

const AComp = ({ children }) => (
  <span className="inline-block bg-[#FFF6DC] text-[#8A6300] font-cond uppercase tracking-[0.06em] text-[12.5px] px-2 py-0.5 rounded-[3px] align-middle">
    {children}
  </span>
);

const MAJ = '28 août 2026';

/* ------------------------------------------------------------------ */

export function MentionsLegales() {
  return (
    <>
      <Seo
        titre="Mentions légales | BATI SELECT TP"
        description="Mentions légales du site de BATI SELECT TP, location d'engins de chantier à Alfortville (94)."
      />
      <Cadre
        titre="Mentions légales"
        chapo="Informations légales relatives à ce site, conformément à l'article 6 III de la loi du 21 juin 2004 pour la confiance dans l'économie numérique."
        enfants={
          <>
            <div>
              <H>Éditeur du site</H>
              <p className="mt-3">
                <strong className="font-semibold">{ENTREPRISE.nom}</strong>
                <br />
                {ENTREPRISE.adresse}, {ENTREPRISE.codePostal} {ENTREPRISE.ville}, France
                <br />
                Téléphone : {ENTREPRISE.telephone}
                <br />
                Email : {ENTREPRISE.email}
              </p>
              <ul className="mt-4 space-y-2 text-[15.5px]">
                <li>Forme juridique : {LEGAL.formeJuridique}</li>
                <li>Capital social : {LEGAL.capital}</li>
                <li>Immatriculation : {LEGAL.rcs}</li>
                <li>Numéro de gestion : {LEGAL.numeroGestion}</li>
                <li>Identifiant européen unique : {LEGAL.euid}</li>
                <li>Numéro de TVA intracommunautaire : {LEGAL.tva}</li>
                <li>Gérant : {LEGAL.gerant}</li>
                <li>Directeur de la publication : {LEGAL.directeurPublication}</li>
              </ul>
              <p className="mt-4 text-[15px] text-beton">
                Greffe compétent : {LEGAL.greffe}.
              </p>
            </div>

            <div>
              <H>Activité</H>
              <p className="mt-3">{LEGAL.activites}</p>
              <p className="mt-3 text-[15px] text-beton">
                Début d'activité : {LEGAL.debutActivite}.
              </p>
            </div>

            <div>
              <H>Assurance professionnelle</H>
              <p className="mt-3">
                Nom de l'assureur, numéro de police et étendue géographique de la couverture :{' '}
                <AComp>à compléter</AComp>
              </p>
            </div>

            <div>
              <H>Hébergement</H>
              <p className="mt-3">
                Le site est hébergé par <strong className="font-semibold">Netlify, Inc.</strong>,
                512 2nd Street, Suite 200, San Francisco, CA 94107, États-Unis.
                Site : www.netlify.com
              </p>
            </div>

            <div>
              <H>Conception et réalisation</H>
              <p className="mt-3">
                Site conçu et réalisé par <strong className="font-semibold">KREEA Média</strong>.
                Le code source et le nom de domaine sont la propriété pleine et entière de{' '}
                {ENTREPRISE.nom}, qui peut en obtenir la remise complète sur simple demande,
                sans frais, sans préavis et sans aucun blocage technique.
              </p>
            </div>

            <div>
              <H>Propriété intellectuelle</H>
              <p className="mt-3">
                L'ensemble des contenus de ce site, textes, photographies, illustrations et
                mise en forme, est la propriété de {ENTREPRISE.nom}, sauf mention contraire.
                Toute reproduction, représentation, adaptation ou exploitation, même
                partielle, est interdite sans autorisation écrite préalable.
              </p>
              <p className="mt-3">
                Les marques et logos des constructeurs cités, notamment Volvo Construction
                Equipment, JCB et Sunward, appartiennent à leurs titulaires respectifs. Ils
                sont mentionnés à titre descriptif, pour identifier le matériel proposé à la
                location.
              </p>
            </div>

            <div>
              <H>Exactitude des informations techniques</H>
              <p className="mt-3">
                Les caractéristiques des machines publiées ici proviennent des documents
                constructeurs et des plaques signalétiques des engins. Elles sont données à
                titre indicatif et peuvent varier selon la configuration exacte de la machine,
                ses équipements et ses accessoires. La masse portée sur la plaque signalétique
                fait foi. Seuls le devis et le contrat de location signés ont valeur
                contractuelle.
              </p>
            </div>

            <div>
              <H>Liens vers d'autres sites</H>
              <p className="mt-3">
                Ce site peut contenir des liens vers des sites tiers. {ENTREPRISE.nom} n'exerce
                aucun contrôle sur leur contenu et décline toute responsabilité quant aux
                informations qui y sont publiées.
              </p>
            </div>

            <div>
              <H>Droit applicable</H>
              <p className="mt-3">
                Le présent site est soumis au droit français. En cas de litige, et à défaut de
                résolution amiable, les tribunaux français sont seuls compétents.
              </p>
            </div>

            <p className="text-[15px] text-beton">Dernière mise à jour : {MAJ}.</p>
          </>
        }
      />
    </>
  );
}

/* ------------------------------------------------------------------ */

export function Confidentialite() {
  return (
    <>
      <Seo
        titre="Politique de confidentialité | BATI SELECT TP"
        description="Comment BATI SELECT TP collecte, utilise et protège les données transmises par le formulaire de demande de devis, conformément au RGPD."
      />
      <Cadre
        titre="Politique de confidentialité"
        chapo="Ce que nous faisons de vos informations, pourquoi, pendant combien de temps, et comment reprendre la main dessus à tout moment."
        enfants={
          <>
            <div>
              <H>Responsable du traitement</H>
              <p className="mt-3">
                <strong className="font-semibold">{ENTREPRISE.nom}</strong>, {LEGAL.formeJuridique}{' '}
                au capital de {LEGAL.capital}, immatriculée sous le numéro {LEGAL.rcs}, dont le
                siège est situé {ENTREPRISE.adresse}, {ENTREPRISE.codePostal} {ENTREPRISE.ville}, France.
                Représentant légal : {LEGAL.gerant}.
                <br />
                Contact pour toute question relative aux données personnelles :{' '}
                <a href={ENTREPRISE.emailLien} className="text-bleu font-semibold underline underline-offset-2">
                  {ENTREPRISE.email}
                </a>{' '}
                ou {ENTREPRISE.telephone}.
              </p>
              <p className="mt-3 text-[15px] text-beton">
                Aucun délégué à la protection des données n'a été désigné, la désignation
                n'étant pas obligatoire au regard de l'activité et du volume de données traité.
              </p>
            </div>

            <div>
              <H>Données que nous collectons</H>
              <p className="mt-3">
                Nous ne collectons que ce que vous nous transmettez volontairement, par le
                formulaire de demande de devis, par email ou par téléphone :
              </p>
              <ul className="mt-3 space-y-2 text-[16px]">
                {[
                  'Votre nom et le nom de votre société',
                  'Votre adresse email et votre numéro de téléphone',
                  'La machine souhaitée, avec ou sans chauffeur',
                  'Vos dates de location et la commune du chantier',
                  "La largeur et la nature de votre accès, ainsi que la description libre de votre besoin",
                ].map((x) => (
                  <li key={x} className="flex gap-3">
                    <span className="mt-2.5 shrink-0 w-2 h-2 bg-jaune" aria-hidden="true" />
                    <span>{x}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-4">
                Aucune donnée sensible au sens de l'article 9 du RGPD n'est demandée ni
                collectée. Le site ne pratique aucun profilage et ne prend aucune décision
                automatisée à votre égard.
              </p>
            </div>

            <div>
              <H>Pourquoi nous les utilisons, et sur quelle base</H>
              <div className="mt-4 overflow-x-auto">
                <table className="w-full min-w-[560px] text-[15.5px] border border-nuit/10">
                  <thead className="bg-nuit text-white">
                    <tr>
                      <th className="text-left font-cond uppercase tracking-[0.06em] text-[14px] px-4 py-2.5">Finalité</th>
                      <th className="text-left font-cond uppercase tracking-[0.06em] text-[14px] px-4 py-2.5">Base légale</th>
                      <th className="text-left font-cond uppercase tracking-[0.06em] text-[14px] px-4 py-2.5">Conservation</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      ['Répondre à votre demande et établir votre devis', 'Votre consentement, article 6.1.a du RGPD', '3 ans après le dernier échange'],
                      ['Exécuter et suivre une location conclue', "Exécution d'un contrat, article 6.1.b", 'Durée du contrat, puis 5 ans'],
                      ['Respecter nos obligations comptables et fiscales', 'Obligation légale, article 6.1.c', '10 ans, article L123-22 du Code de commerce'],
                      ['Prévenir les envois automatisés indésirables', 'Intérêt légitime, article 6.1.f', 'Le temps du traitement de la demande'],
                    ].map((l) => (
                      <tr key={l[0]} className="border-t border-nuit/10 align-top">
                        <td className="px-4 py-3">{l[0]}</td>
                        <td className="px-4 py-3 text-beton">{l[1]}</td>
                        <td className="px-4 py-3 font-semibold">{l[2]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="mt-4">
                Au terme de ces durées, les données sont supprimées ou archivées sous une forme
                ne permettant plus de vous identifier.
              </p>
            </div>

            <div>
              <H>Qui accède à vos données</H>
              <p className="mt-3">
                Vos données ne sont ni vendues, ni louées, ni cédées à des tiers à des fins
                commerciales. Y accèdent uniquement :
              </p>
              <ul className="mt-3 space-y-2 text-[16px]">
                <li className="flex gap-3">
                  <span className="mt-2.5 shrink-0 w-2 h-2 bg-jaune" aria-hidden="true" />
                  <span>
                    <strong className="font-semibold">L'équipe de {ENTREPRISE.nom}</strong>,
                    strictement pour traiter votre demande.
                  </span>
                </li>
                <li className="flex gap-3">
                  <span className="mt-2.5 shrink-0 w-2 h-2 bg-jaune" aria-hidden="true" />
                  <span>
                    <strong className="font-semibold">Netlify, Inc.</strong>, sous-traitant au
                    sens de l'article 28 du RGPD, qui héberge le site et achemine les envois du
                    formulaire vers notre boîte email.
                  </span>
                </li>
              </ul>
              <p className="mt-4">
                <strong className="font-semibold">Transfert hors Union européenne.</strong>{' '}
                Netlify étant une société américaine, vos données peuvent être traitées aux
                États-Unis. Ce transfert est encadré par les clauses contractuelles types de la
                Commission européenne intégrées aux conditions de service de Netlify, ainsi que
                par sa certification au titre du cadre de protection des données entre l'Union
                européenne et les États-Unis.
              </p>
            </div>

            <div>
              <H>Sécurité</H>
              <p className="mt-3">
                Le site est entièrement servi en HTTPS, ce qui chiffre les échanges entre votre
                navigateur et nos serveurs. Les demandes reçues ne sont accessibles qu'aux
                personnes habilitées de l'entreprise, via des accès protégés par mot de passe.
                Aucune base de données publique n'est exposée par le site.
              </p>
            </div>

            <div>
              <H>Vos droits</H>
              <p className="mt-3">
                Conformément aux articles 15 à 22 du RGPD et à la loi Informatique et Libertés,
                vous disposez des droits suivants :
              </p>
              <ul className="mt-3 space-y-2 text-[16px]">
                {[
                  ['Accès', 'obtenir la confirmation que nous traitons vos données, et en recevoir une copie'],
                  ['Rectification', 'faire corriger une information inexacte ou incomplète'],
                  ['Effacement', 'demander la suppression de vos données'],
                  ['Limitation', 'demander le gel temporaire du traitement'],
                  ['Opposition', "vous opposer à un traitement fondé sur notre intérêt légitime"],
                  ['Portabilité', 'récupérer vos données dans un format lisible par machine'],
                  ['Retrait du consentement', "revenir à tout moment sur l'accord donné lors de l'envoi du formulaire, sans que cela remette en cause la licéité du traitement effectué avant ce retrait"],
                  ['Directives post mortem', 'définir le sort de vos données après votre décès'],
                ].map(([t, d]) => (
                  <li key={t} className="flex gap-3">
                    <span className="mt-2.5 shrink-0 w-2 h-2 bg-bleu" aria-hidden="true" />
                    <span>
                      <strong className="font-semibold">{t} : </strong>
                      {d}.
                    </span>
                  </li>
                ))}
              </ul>
              <p className="mt-4">
                Pour exercer l'un de ces droits, écrivez à{' '}
                <a href={ENTREPRISE.emailLien} className="text-bleu font-semibold underline underline-offset-2">
                  {ENTREPRISE.email}
                </a>{' '}
                ou à l'adresse postale ci-dessus. Nous répondons dans un délai d'un mois,
                prolongeable de deux mois si la demande est complexe. Une preuve d'identité peut
                être demandée en cas de doute raisonnable sur l'identité du demandeur.
              </p>
              <p className="mt-3">
                Si la réponse ne vous satisfait pas, vous pouvez introduire une réclamation
                auprès de la Commission nationale de l'informatique et des libertés, 3 place de
                Fontenoy, TSA 80715, 75334 Paris Cedex 07, ou en ligne sur www.cnil.fr.
              </p>
            </div>

            <div>
              <H>Cookies</H>
              <p className="mt-3">
                Ce site ne dépose aucun cookie publicitaire ni traceur de mesure d'audience.
                Le détail figure sur notre{' '}
                <Link to="/cookies" className="text-bleu font-semibold underline underline-offset-2">
                  page dédiée aux cookies
                </Link>
                .
              </p>
            </div>

            <div>
              <H>Modification de cette politique</H>
              <p className="mt-3">
                Cette politique peut évoluer, notamment en cas de changement d'outil ou de
                réglementation. La date de dernière mise à jour figure ci-dessous.
              </p>
            </div>

            <p className="text-[15px] text-beton">Dernière mise à jour : {MAJ}.</p>
          </>
        }
      />
    </>
  );
}

/* ------------------------------------------------------------------ */

export function Cookies() {
  return (
    <>
      <Seo
        titre="Politique de cookies | BATI SELECT TP"
        description="Quels cookies ce site utilise, à quoi ils servent, combien de temps ils sont conservés et comment revenir sur votre choix à tout moment."
      />
      <Cadre
        titre="Politique de cookies"
        chapo="Ce que nous déposons sur votre appareil, pourquoi, pour combien de temps, et comment reprendre la main en deux clics."
        enfants={
          <>
            <div>
              <H>Ce qu'est un cookie</H>
              <p className="mt-3">
                Un cookie est un petit fichier déposé sur votre appareil lors de la visite d'un
                site. Il peut servir à faire fonctionner le site, à mesurer sa fréquentation, ou
                à vous suivre d'un site à l'autre à des fins publicitaires. Seule la première
                catégorie peut être déposée sans votre accord.
              </p>
              <p className="mt-3">
                <strong className="font-semibold">
                  Nous n'utilisons aucun cookie publicitaire et ne revendons aucune donnée.
                </strong>{' '}
                Le bandeau affiché à votre première visite vous laisse accepter ou refuser
                catégorie par catégorie. Refuser ne limite en rien votre navigation.
              </p>
            </div>

            <div>
              <H>Les trois catégories</H>
              <div className="mt-4 space-y-4">
                {CATEGORIES.map((c) => (
                  <div key={c.id} className="carte p-5 border-l-4 border-l-bleu">
                    <h3 className="font-cond uppercase font-bold tracking-[0.05em] text-[17px] text-nuit">
                      {c.titre}
                      {c.verrouille && (
                        <span className="ml-2 font-normal normal-case tracking-normal text-[14px] text-beton">
                          toujours actifs, exemptés de consentement
                        </span>
                      )}
                    </h3>
                    <p className="mt-2 text-nuit/75 text-[16px]">{c.texte}</p>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <H>Le détail, cookie par cookie</H>
              <div className="mt-4 overflow-x-auto">
                <table className="w-full min-w-[620px] text-[15.5px] border border-nuit/10">
                  <thead className="bg-nuit text-white">
                    <tr>
                      <th className="text-left font-cond uppercase tracking-[0.06em] text-[14px] px-4 py-2.5">Nom</th>
                      <th className="text-left font-cond uppercase tracking-[0.06em] text-[14px] px-4 py-2.5">Déposé par</th>
                      <th className="text-left font-cond uppercase tracking-[0.06em] text-[14px] px-4 py-2.5">Rôle</th>
                      <th className="text-left font-cond uppercase tracking-[0.06em] text-[14px] px-4 py-2.5">Durée</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      ['bstp-consentement', 'Ce site', 'Mémorise votre choix pour ne plus vous afficher le bandeau', '6 mois'],
                      ['_ga, _gid', 'Mesure d\'audience', 'Distingue les visiteurs et les sessions pour établir les statistiques de fréquentation', '13 mois maximum'],
                      ['Cookie technique de carte', 'Fondation OpenStreetMap', "Permet l'affichage des tuiles cartographiques", 'Session'],
                    ].map((l) => (
                      <tr key={l[0]} className="border-t border-nuit/10 align-top">
                        <td className="px-4 py-3 font-semibold">{l[0]}</td>
                        <td className="px-4 py-3 text-beton">{l[1]}</td>
                        <td className="px-4 py-3">{l[2]}</td>
                        <td className="px-4 py-3 font-semibold">{l[3]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="mt-4 text-[15px] text-beton">
                Les cookies de mesure d'audience et de carte ne sont déposés qu'après votre
                accord. Tant que vous n'avez pas répondu au bandeau, ou si vous refusez, aucun
                d'eux n'est présent sur votre appareil.
              </p>
            </div>

            <div>
              <H>La carte de notre dépôt</H>
              <p className="mt-3">
                La carte OpenStreetMap proposée sur la page de contact et en bas de la page
                d'accueil{' '}
                <strong className="font-semibold">ne se charge pas automatiquement</strong> si
                vous n'avez pas accepté les contenus extérieurs. Rien n'est envoyé à
                OpenStreetMap tant que vous n'avez pas cliqué sur « Afficher la carte ».
              </p>
              <p className="mt-3">
                Si vous cliquez, votre navigateur contacte alors les serveurs de la fondation
                OpenStreetMap, qui reçoit votre adresse IP. Sa politique est consultable sur
                osmfoundation.org. Si vous préférez éviter ce chargement, n'appuyez pas sur le
                bouton : l'adresse du dépôt reste affichée en clair, et un lien vers Google Maps
                s'ouvre dans un nouvel onglet, sous votre seul contrôle.
              </p>
            </div>

            <div>
              <H>Le formulaire de devis</H>
              <p className="mt-3">
                L'envoi du formulaire ne dépose aucun cookie. Il transmet uniquement les
                informations que vous avez saisies, via le service de formulaires de notre
                hébergeur Netlify. Le traitement de ces informations est décrit dans notre{' '}
                <Link to="/confidentialite" className="text-bleu font-semibold underline underline-offset-2">
                  politique de confidentialité
                </Link>
                .
              </p>
            </div>

            <div>
              <H>Revenir sur votre choix</H>
              <p className="mt-3">
                Votre décision est conservée dans le stockage local de votre navigateur, sur
                votre seul appareil. Elle ne nous est jamais transmise et n'est associée à aucun
                identifiant. Pour la modifier, utilisez le lien{' '}
                <strong className="font-semibold">« Gérer mes cookies »</strong> en bas de chaque
                page : le bandeau réapparaît et votre nouveau choix remplace l'ancien. Si vous
                retirez votre accord à la mesure d'audience, les cookies correspondants sont
                supprimés de votre appareil.
              </p>
              <p className="mt-3">
                Conformément aux recommandations de la CNIL, votre choix est conservé six mois.
                Passé ce délai, le bandeau vous est présenté à nouveau.
              </p>
            </div>

            <div>
              <H>Garder la main sur votre navigateur</H>
              <p className="mt-3">
                Indépendamment de ce site, vous pouvez à tout moment bloquer ou supprimer les
                cookies depuis les réglages de votre navigateur, dans la rubrique consacrée à la
                confidentialité ou aux données de navigation. Ce blocage n'affecte en rien le
                fonctionnement du présent site.
              </p>
            </div>

            <p className="text-[15px] text-beton">Dernière mise à jour : {MAJ}.</p>
          </>
        }
      />
    </>
  );
}

/* ------------------------------------------------------------------ */

export function ChartAvis() {
  return (
    <>
      <Seo
        titre="Charte des avis clients | BATI SELECT TP"
        description="Comment les avis clients sont recueillis, publiés et retirés sur le site de BATI SELECT TP, conformément à l'article L111-7-2 du code de la consommation."
      />
      <Cadre
        titre="Charte des avis clients"
        chapo="Comment les avis sont recueillis, publiés et, dans certains cas seulement, retirés. Document établi conformément à l'article L111-7-2 du code de la consommation."
        enfants={
          <>
            <p className="text-[15px] text-beton">Dernière mise à jour : {MAJ}</p>

            <div className="space-y-3">
              <H>Qui peut déposer un avis</H>
              <p>
                Toute personne ayant loué du matériel chez {ENTREPRISE.nom} peut déposer un avis
                depuis la section « La parole aux chantiers », présente sur les principales pages
                du site. Aucun compte n'est nécessaire.
              </p>
            </div>

            <div className="space-y-3">
              <H>Les avis sont vérifiés avant publication</H>
              <p>
                Chaque avis reçu est <strong>rapproché d'une location réelle</strong> figurant dans
                nos registres, à partir du nom, de l'entreprise, de la commune du chantier et de la
                machine indiqués par l'auteur. Un avis qui ne correspond à aucune location retrouvée
                n'est pas publié.
              </p>
              <p>
                La publication intervient donc après ce contrôle, en général <strong>sous deux jours
                ouvrés</strong>. Aucun avis n'est mis en ligne automatiquement. L'adresse
                électronique demandée à l'auteur sert exclusivement à ce contrôle et à le prévenir
                si son avis ne peut pas être publié ; elle n'est jamais affichée.
              </p>
            </div>

            <div className="space-y-3">
              <H>Aucune contrepartie</H>
              <p>
                Aucune remise, aucun avantage commercial et aucune rémunération ne sont accordés
                en échange du dépôt d'un avis. Nous ne sollicitons pas d'avis rémunérés et
                n'achetons aucun avis auprès de tiers.
              </p>
            </div>

            <div className="space-y-3">
              <H>Comment les avis sont classés</H>
              <p>
                Les avis sont affichés <strong>par date de chantier, de la plus récente à la plus
                ancienne</strong>. Ce classement est le seul appliqué : il n'existe aucun tri par
                note, aucune mise en avant payante et aucune sélection éditoriale. La note affichée
                sur le site est la moyenne arithmétique de l'ensemble des avis publiés, arrondie au
                dixième.
              </p>
            </div>

            <div className="space-y-3">
              <H>Ce que nous publions</H>
              <p>
                Sont publiés : la note sur cinq, le texte de l'avis, l'identité choisie par l'auteur,
                la commune du chantier, la machine concernée, <strong>le mois du chantier</strong> et
                <strong>la date de publication de l'avis</strong>. L'auteur choisit lui-même la façon
                dont il apparaît : nom et entreprise, entreprise seule, prénom et initiale, ou
                anonymement. Son adresse électronique n'est jamais publiée.
              </p>
            </div>

            <div className="space-y-3">
              <H>Dans quels cas un avis peut être retiré</H>
              <p>
                Un avis n'est retiré que s'il relève d'un des cas suivants :
              </p>
              <ul className="space-y-2 list-disc pl-5">
                <li>contenu injurieux, grossier, menaçant ou discriminatoire ;</li>
                <li>contenu diffamatoire, ou mettant en cause nommément une personne physique ;</li>
                <li>contenu manifestement hors sujet, publicitaire ou frauduleux ;</li>
                <li>avis manifestement faux, notamment déposé par un concurrent ;</li>
                <li>contenu portant atteinte à la vie privée ou publiant des données personnelles de tiers ;</li>
                <li>contenu contraire à la loi.</li>
              </ul>
              <p>
                <strong>Un avis négatif portant sur une prestation réellement effectuée n'est jamais
                retiré.</strong> Nous préférons y répondre publiquement. Lorsqu'un avis est refusé
                ou retiré, l'auteur en est informé et le motif lui est communiqué, dès lors qu'il
                nous a laissé un moyen de le joindre.
              </p>
            </div>

            <div className="space-y-3">
              <H>Délai entre le chantier et l'avis</H>
              <p>
                L'auteur indique lui-même le mois du chantier concerné, qui peut être antérieur de
                plusieurs années. C'est cette date qui est affichée en évidence sous chaque avis,
                car elle correspond à l'expérience vécue. La date à laquelle l'avis a été publié sur
                le site figure juste en dessous.
              </p>
            </div>

            <div className="space-y-3">
              <H>Signaler un avis</H>
              <p>
                Si un avis vous paraît relever d'un des cas ci-dessus, écrivez-nous à{' '}
                <a href={ENTREPRISE.emailLien} className="text-bleu underline">{ENTREPRISE.email}</a> en
                indiquant l'auteur, la date et le motif. Nous examinons le signalement et répondons
                dans un délai raisonnable.
              </p>
            </div>

            <div className="space-y-3">
              <H>Vos données et vos droits</H>
              <p>
                Le dépôt d'un avis vaut consentement à sa publication, recueilli par une case à
                cocher avant l'envoi. Les avis sont conservés tant qu'ils sont publiés. Vous pouvez
                à tout moment demander la rectification ou la suppression de votre avis et des
                données qui l'accompagnent en écrivant à{' '}
                <a href={ENTREPRISE.emailLien} className="text-bleu underline">{ENTREPRISE.email}</a>.
                Le détail de vos droits figure dans notre{' '}
                <Link to="/confidentialite" className="text-bleu underline">politique de confidentialité</Link>.
              </p>
            </div>

            <div className="space-y-3">
              <H>Durée de conservation et archivage</H>
              <p>
                Les avis restent en ligne sans limite de durée tant qu'ils ne sont pas retirés à la
                demande de leur auteur ou pour l'un des motifs listés ci-dessus. Aucun avis n'est
                archivé de façon à en masquer le contenu tout en conservant la note.
              </p>
            </div>
          </>
        }
      />
    </>
  );
}
